import { ShopCurrencies, SteamPaymentFormData, TransactionStatus } from './types'
import { createEvent } from 'effector'
import { SubscriptionPaymentOptions } from './types'

export const updateSteamPaymentForm = createEvent<SteamPaymentFormData>()
export const updateTransactionStatus = createEvent<TransactionStatus>()
export const changeSubscriptionPaymentOption = createEvent<SubscriptionPaymentOptions>()
export const changeShopCurrency = createEvent<ShopCurrencies>()
